/* eslint-disable */
import React, { Component } from "react";
import { withRouter } from "../../../withRouter";
import { connect } from "react-redux";
import cookie from "react-cookies";
/* import moment from "moment"; */
import axios from "axios";
/* import Select from "react-select"; */
import { apiUrl, adminlimit, clientheaderconfig } from "../../Helpers/Config";
import { GET_LISTDATA } from "../../../actions";
import { removeItem/* , showDateTime, showPriceValue, showRecords */ } from "../../Helpers/SettingHelper";
import Header from "../Layout/Header";
import Topmenu from "../Layout/Topmenu";
import Footer from "../Layout/Footer";
/* import Pagenation from "../Layout/Pagenation"; */
import Reviews from "./Review/Dashboard.tsx";
import Settings from "./Review/Settings.tsx";
import SupabaseLogin from "./SupabaseLogin.tsx";
/* import whatsapp from "../../../common/images/whatsapp.svg"; */

var module = "rating";
var moduleName = "Rating";
class List extends Component {
  constructor(props) {
    super(props);
    console.log(this.props, 'propspropspropsprops')
    var companyID = cookie.load("companyID");
    this.state = {
      supabaseoutletIDs_:[],
      companyID: companyID,
      clientAllowOutlet: cookie.load('clientAllowOutlet') ?? '',
      path: this.props?.location?.pathname || '',
      totalRecords: 0,
      totalPage: 0,
      currentPage: 1,
      listdata: [],
      loading: true,
      outletList: [],
      ratingCount: [],
      rating: [],
      filterOutlet:"",
      filterRating:"",
      searchKeyword:"",
    };
    this.handleChangeText = this.handleChangeText.bind(this);
  }
  componentDidMount() {
    //this.loadList(1);
    this.loadOutlet();
  }
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.listdata !== this.state.listdata) {
      this.setState({
        listdata: nextProps.listdata,
        /* loading: false, */
        totalRecords: nextProps.totalRecords,
        totalPage: nextProps.totalPages,
      });
    }
    if (this.state.ratingCount !== nextProps.listdata) {
      this.setState({ ratingCount: nextProps.ratingCount });
    }
  }
  sateValChange = (field, value) => {
    if (field === "page") {
      this.setState(
        {
         /*  loading: true, */
          currentPage: value,
        }, () => {
          this.loadList(value);
        }
      );
    } else if(field==='applyFilter') {
      console.log(value, 'valuevaluevaluevalue')
      const valueSplit = value.split('__');
      let filterOutlet = ''; let filterRating = ''; let searchKeyword = '';
      if(valueSplit[1]!=="" && valueSplit[1]!=='all') {
        filterOutlet = valueSplit[1] ?? ''
      }
      if(valueSplit[0]!=="" && valueSplit[0]!=='all') {
        filterRating = valueSplit[0] ?? ''
      }
      if(valueSplit[2]!=="" &&  valueSplit[2]!=='all') {
        searchKeyword = valueSplit[2] ?? '';
      }
      console.log(valueSplit, filterRating, filterOutlet, searchKeyword,'filterRating')
      this.setState({/*  loading: true, */ filterOutlet,  filterRating,  searchKeyword, }, () => {
        this.loadList(1);
      });
    }
  };
  loadOutlet() {
    var urlShringTxt = apiUrl + "outlet/dropdown?company_id=" + this.state.companyID;
    axios
      .get(urlShringTxt, clientheaderconfig)
      .then((res) => {
        if (res.data.status === "ok") {
          const result =  res.data.result;
          const ids = result.filter(item => item.supabaseOutletID && item.supabaseOutletID.trim() !== "").map(item => item.supabaseOutletID);
          this.setState({ outletList: result, loading:false, supabaseoutletIDs_:ids }, ()=> {
            if(this.state.supabaseoutletIDs_.length===0) {
              this.props.navigate('/clientpanel/rating/setting');
            }
          });
        }
      })
      .catch();
  }
  removeItem(deleteID) {
    var params = { delete_id: deleteID, company_id: this.state.companyID };
    var delurl = module + "delete";
    removeItem(params, delurl, "client");
  }
  handleChangeText(event) {
    var name = event.target.name;
    var value = event.target.value;
    this.setState({ [name]: value });
  }
  handleSelectChange(name, value) {
    this.setState({ [name]: value });
  }

  handleChangeDate(name, value) {
    this.setState({ [name]: value });
  }

  searchList() {
    /* this.setState({ loading: true }, function () {
      this.loadList(1);
    }); */
  }
  loadList(offset) {
    let addParams = "limit=" + adminlimit + "&offset=" + offset;
    const filterRating = this.state.filterRating || "";
    if (filterRating!=="") {
      addParams += "&rating=" + filterRating;
    }
    if(this.state.clientAllowOutlet!=="") {
      addParams += "&outeltID=" + this.state.clientAllowOutlet;
    }else {
      const filterOutlet = this.state.filterOutlet || "";
      console.log(filterOutlet, 'filterOutletfilterOutletfilterOutletfilterOutlet')
      if (filterOutlet!=="") {
        addParams += "&outeltID=" + filterOutlet;
      }
    }
    const searchKeyword = this.state.searchKeyword || "";
    if (searchKeyword!=="") {
      addParams += "&searchKeyword=" + searchKeyword;
    }

    var params = {
      params: addParams,
      url: apiUrl + module + "/list",
      authType: "client",
    };
    this.props.getListData(params);
  }
  resetSearch() {
    this.setState(
      {
       /*  loading: true, */
        outletList: [],
        rating: [],
      },
      function () {
        this.loadList(1);
      }
    );
  }
  selectRating(ratingNumber) {
    this.setState(
      (prevState) => {
        const exists = prevState.rating.some((item) => item.value === ratingNumber);

        if (exists) {
          // remove it
          return {
            rating: prevState.rating.filter((item) => item.value !== ratingNumber),
          };
        } else {
          // add it
          return {
            rating: [...prevState.rating, { label: ratingNumber, value: ratingNumber }],
          };
        }
      },
      () => {
        console.log(this.state.rating, "ratingratingrating");
        // callback after state update
        this.loadList(1);
      }
    );
  }
  onRecallOulet(recall) {
    if(recall===true) {
    /*   const supabaseoutletIDs1 = localStorage.getItem('supabaseoutletIDs') ?? '';
      const supabaseoutletIDs1_ = supabaseoutletIDs1 !== '' ? [...new Set(supabaseoutletIDs1.split(','))] : [];
      this.setState({supabaseoutletIDs_:supabaseoutletIDs1_}) */
      this.loadOutlet();
    }
  }

  render() {
    return (
      <div className="layout-wrapper layout-content-navbar reviewpage">
        <div className="layout-container">
          <SupabaseLogin />
          <Header {...this.props} currentPage={"rating"} />
          <div className="layout-page">
            <Topmenu />

            <div className="content-wrapper">
              <div className="container-xxl flex-grow-1 container-p-y">
                {/* <div className="row mb-3">
                  <div className="col-lg-10 col-md-6">
                    <h4 className="fw-bold">{moduleName}</h4>
                  </div>
                </div> */}
                {this.state.outletList.length>0 &&
                <div>
                {this.props.location.pathname==="/clientpanel/rating/setting" ?(
                  <Settings props={this.props} outletList={this.state.outletList} supabaseoutletIDs={this.state.supabaseoutletIDs_} onRecallOulet={this.onRecallOulet.bind(this)}  />
                ):(
                  this.state.supabaseoutletIDs_.length>0 &&
                    (<Reviews  props={this.props}  supabaseoutletIDs={this.state.supabaseoutletIDs_}  />)
                  
                )}
                </div>}
                
                {/* <Pagenation
                    params={{
                      totalRecords: this.state.totalRecords,
                      totalPage: this.state.totalPage,
                      currentPage: this.state.currentPage,
                    }}
                    sateValChange={this.sateValChange}
                  /> */}

              {/*   <div className="row mb-4">
                  {this.state.ratingCount.length > 0 &&
                    this.state.ratingCount.map((item, index) => {
                      const checkingItem = this.state.rating.some((ritem) => ritem.value === item.ratingNumber);

                      return (
                        <div className="col-lg-2 col-sm-2" key={index} onClick={this.selectRating.bind(this, item.ratingNumber)}>
                          <div className="card ">
                            <div className={`card-header ${checkingItem ? "bg-label-primary" : ""}`}>
                              <div className="d-flex align-items-end mb-1 flex-wrap gap-2 p-2">
                                <h4 className="mb-0 me-2">{item.ratingNumber} Star</h4>
                                <h5 className="mb-0 text-success">
                                  {item.totalRaing}
                                  {parseFloat(item.totalRaing) > 0 && <>({item.avarageRating}%)</>}
                                </h5>
                              </div>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                </div>

                <div className="row mb-4 pro-filter-row">
                  <div className="col-md-3 pro-filter-outlet">
                    <div className="form-floating form-floating-outline custm-select-box filter-select mb-4">
                      <Select value={this.state.storeID} onChange={this.handleSelectChange.bind(this, "storeID")} placeholder="Select Outlet" isClearable={true} options={this.state.outletList} />
                      <label className="select-box-label">Outlet</label>
                    </div>
                  </div>
                  <div className="col-md-3 pro-filter-outlet">
                    <div className="form-floating form-floating-outline custm-select-box filter-select mb-4">
                      <Select
                        value={this.state.rating}
                        onChange={this.handleSelectChange.bind(this, "rating")}
                        placeholder="Select Rating"
                        isClearable={true}
                        isMulti={true}
                        options={[
                          {
                            label: "1",
                            value: "1",
                          },
                          {
                            label: "2",
                            value: "2",
                          },
                          {
                            label: "3",
                            value: "3",
                          },
                          {
                            label: "4",
                            value: "4",
                          },
                          {
                            label: "5",
                            value: "5",
                          },
                        ]}
                      />
                      <label className="select-box-label">Rating</label>
                    </div>
                  </div>
                  <div className="col-md-1 pt-2 pro-filter-sbtbtn">
                    <button type="button" className="btn btn-primary me-sm-3 me-1 waves-effect waves-light" onClick={this.searchList.bind(this)}>
                      Search
                    </button>
                  </div>

                  <div className="col-md-1 pt-2 pro-filter-refbtn">
                    <button type="reset" className="btn btn-label-secondary waves-effect" onClick={this.resetSearch.bind(this)}>
                      Reset
                    </button>
                  </div>
                </div>

                <div className="card">
                  <div className="p-1 mt-4">
                    {parseInt(this.state.totalPage) > 0 && showRecords(this.state.currentPage, this.state.totalRecords, moduleName)}
                    <div className="table-responsive text-nowrap">
                      <table className="table">
                        <thead>
                          <tr>
                            <th>Outlet</th>
                            <th>Name</th>
                            <th>Email</th>
                            <th>Phone</th>
                            <th>Whatsapp</th>
                            <th>Rating</th>
                            <th>Message</th>
                            <th>Spend Amount</th>
                            <th>Buy Amount</th>
                             <th>Buy Voucher Name</th> 
                            <th>Created ON</th>
                          </tr>
                        </thead>
                        <tbody>
                          {this.state.loading === true ? (
                            <tr>
                              <td colSpan={6} align="center">
                                <div className="spinner-border spinner-border-lg text-primary" role="status">
                                  <span className="visually-hidden">Loading...</span>
                                </div>
                              </td>
                            </tr>
                          ) : this.state.listdata.length > 0 ? (
                            this.state.listdata.map((item, index) => {
                              return (
                                <tr key={index}>
                                  <td>
                                    <strong>{item.outlet?.outletName || ""}</strong>
                                  </td>
                                  <td>
                                    <strong>{item.ratingName}</strong>
                                  </td>
                                  <td>{item.ratingEmail}</td>
                                  <td>
                                    <a href={`tel:+65${item.ratingPhone}`}>{item.ratingPhone}</a>
                                  </td>
                                  <td className="text-center">
                                    <a href={`https://wa.me/+65${item.ratingPhone}`} target="_blank">
                                      <img src={whatsapp} alt="whatsapp" style={{ width: "25px" }} />
                                    </a>
                                  </td>
                                  <td>{item.ratingNumber}</td>
                                  <td>{item.ratingMessage}</td>
                                  <td>{showPriceValue(item.transQRUseredAmount)}</td>
                                  <td>{showPriceValue(item.transProductPrice)}</td>
                                 <td>{parseFloat(item.transProductPrice)>0?item.transVoucherName:''}</td> 
                                  <td>{showDateTime(item.createdAt)}</td>
                                </tr>
                              );
                            })
                          ) : (
                            <tr>
                              <td className="text-center" colSpan={8}>
                                No {moduleName} Found
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                  
                </div> */}
              </div>

              <Footer />
            </div>
          </div>
        </div>

        <div className="layout-overlay layout-menu-toggle"></div>

        <div className="drag-target"></div>
      </div>
    );
  }
}

const mapStateTopProps = (state) => {
  var listdata = Array();
  var listdataStatus = "";
  var totalPages = 0;
  var totalRecords = 0;
  var ratingCount = [];
  if (Object.keys(state.listdata).length > 0) {
    listdataStatus = state.listdata[0].status;
    if (state.listdata[0].status === "ok") {
      listdata = state.listdata[0].result;
      totalPages = state.listdata[0].totalPages;
      totalRecords = state.listdata[0].totalRecords;
      ratingCount = state.listdata[0]?.ratingCount || [];
    } else {
      ratingCount = state.listdata[0]?.ratingCount || [];
    }
  }
  return {
    listdata: listdata,
    totalPages: totalPages,
    totalRecords: totalRecords,
    ratingCount: ratingCount,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getListData: (datas) => {
      dispatch({ type: GET_LISTDATA, datas });
    },
  };
};

export default withRouter(connect(mapStateTopProps, mapDispatchToProps)(List));
